import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Taetigkeit } from '@chancenwerk/db/semantics/Taetigkeit.js';
import type { Vertragsarten } from '@chancenwerk/master-data-management/users/entities/Mitarbeiter.js';
import { DateTime } from 'luxon';

/**
 * @entity CRVertrag
 */
@Entity()
export class CRVertrag extends AdornisEntity {
  public static override _class = 'CRVertrag';

  @Field(type => ID, { default: v => v ?? A.getGloballyUniqueID() })
  public _id!: string;

  @Field(type => DateTime, { default: v => v ?? DateTime.now() })
  public startDatum: Maybe<DateTime>;

  @Field(type => String)
  public vertragsart: Maybe<Vertragsarten>;

  @Field(type => [String], { default: v => v ?? [] })
  public taetigkeitenIDs: Maybe<string[]>;

  @DataLoadedField(type => [Taetigkeit], ({ taetigkeitenIDs }) => taetigkeitenIDs ?? [])
  public taetigkeiten: Maybe<Taetigkeit[]>;
}
